export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export const DAYS_SUNDAY_START = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export const DAYS_MONDAY_START = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

export const DAYS_SHORT_SUNDAY_START = ['S', 'M', 'T', 'W', 'T', 'F', 'S'] as const;

export const DAYS_SHORT_MONDAY_START = ['M', 'T', 'W', 'T', 'F', 'S', 'S'] as const;

export const DAYS_HEADERS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as const;

export const BOOKING_BUFFER_HOURS = 48;

export const HOURS_IN_DAY = 24;
export const DAYS_IN_WEEK = 7;
export const DAYS_IN_YEAR = 365;
export const MONTHS_IN_YEAR = 12;
export const FIRST_MONTH = 0;
export const LAST_MONTH = 11;
export const DAY_INCREMENT = 1;
export const WEEK_INCREMENT = 7;
export const MONTH_INCREMENT = 1;
export const YEAR_INCREMENT = 1;

export const SUNDAY = 0;
export const SATURDAY = 6;
export const START_HOUR = 0;
export const START_MINUTE = 0;
export const START_SECOND = 0;
export const START_MILLISECOND = 0;
export const SUNDAY_DIFF = 6;

export const VIEW_BUTTONS = [
  { view: 'day', label: 'Day' },
  { view: 'week', label: 'Week' },
  { view: 'month', label: 'Month' },
  { view: 'year', label: 'Year' },
] as const;

export const CALENDAR_CLASSNAMES = {
  heading: 'text-base font-semibold text-gray-900 dark:text-white',
  headingSmall: 'flex-auto text-sm font-semibold text-gray-900 dark:text-white',
  navButton:
    '-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-white',
  icon: 'size-5',
  iconGray: 'size-5 text-gray-400 dark:text-gray-500',
  menuItem:
    'block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden dark:text-gray-300 dark:data-focus:bg-white/5 dark:data-focus:text-white',
  menuItems:
    'absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10',
  meetingName: 'text-gray-900 dark:text-white',
} as const;

export const CALL_STATUS_STYLES = {
  accepted: {
    button: 'bg-green-100 hover:bg-green-200',
    dayView: 'bg-green-50 border border-green-200 hover:bg-green-100',
    dot: 'bg-green-500',
  },
  rejected: {
    button: 'bg-red-100 hover:bg-red-200',
    dayView: 'bg-red-50 border border-red-200 hover:bg-red-100',
    dot: 'bg-red-500',
  },
  pending: {
    button: 'bg-orange-100 hover:bg-orange-200',
    dayView: 'bg-orange-50 border border-orange-200 hover:bg-orange-100',
    dot: 'bg-orange-500',
  },
} as const;
